import { useDispatch } from 'react-redux';
import { useRouter } from '@shared/router';
import { useRefund } from '../providers/RefundProvider';
import { setRefundLoading } from '../model/loading/actions';

export const useBackToOrder = (needUpdate: boolean = false) => {
	const router = useRouter();
	const dispatch = useDispatch();
	const { updateOrder } = useRefund();

	const onBackToOrder = async () => {
		if (needUpdate) {
			try {
				dispatch(setRefundLoading('updateOrder', true));
				await updateOrder();
			} finally {
				dispatch(setRefundLoading('updateOrder', false));
			}
		}

		router.navigate('/order');
	};

	return { onBackToOrder };
};
